import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { pricing } from '../data/mock';

const Pricing = () => {
  const seasonalPricing = [
    {
      category: 'Ubytování - osoby',
      items: pricing.filter(p => p.item.includes('osoba') || p.item.includes('Dítě') && !p.item.includes('chatce'))
    },
    {
      category: 'Ubytování v chatkách',
      items: pricing.filter(p => p.item.includes('chatce'))
    },
    {
      category: 'Dopravní prostředky',
      items: pricing.filter(p => ['Stan', 'Auto', 'Motorka', 'Karavan', 'Elektřina'].includes(p.item))
    },
    {
      category: 'Ostatní',
      items: pricing.filter(p => p.item === 'Zvíře' || p.item === 'Rekreační poplatek')
    }
  ];

  return (
    <section id="pricing" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Ceník
          </h2>
          <div className="w-24 h-1 bg-emerald-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600">
            Přehledný ceník pro letní sezónu
          </p>
          <Badge className="mt-4 bg-emerald-600 text-white px-4 py-2">
            Sezóna - Léto
          </Badge>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto mb-12">
          {seasonalPricing.map((category, index) => (
            <Card
              key={index}
              className="overflow-hidden border-2 border-gray-100 hover:border-emerald-200 hover:shadow-xl transition-all duration-300"
            >
              <CardHeader className="bg-gradient-to-r from-emerald-600 to-emerald-700">
                <CardTitle className="text-white text-xl">
                  {category.category}
                </CardTitle>
              </CardHeader>
              <CardContent className="p-0">
                <div className="divide-y divide-gray-100">
                  {category.items.map((item, idx) => (
                    <div
                      key={idx}
                      className="p-4 hover:bg-emerald-50 transition-colors flex justify-between items-center"
                    >
                      <span className="text-gray-700 font-medium">
                        {item.item}
                      </span>
                      <span className="text-emerald-600 font-bold text-lg">
                        {item.price} {item.unit}
                      </span>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="max-w-4xl mx-auto">
          <Card className="bg-gradient-to-br from-amber-50 to-amber-100 border-2 border-amber-200">
            <CardContent className="p-8">
              <div className="text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  💡 Důležité informace
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
                  <div className="bg-white rounded-lg p-4 shadow-sm">
                    <p className="font-semibold text-gray-900 mb-2">Děti v chatkách</p>
                    <p className="text-sm text-gray-600">Zvýhodněná cena pro děti do 15 let</p>
                  </div>
                  <div className="bg-white rounded-lg p-4 shadow-sm">
                    <p className="font-semibold text-gray-900 mb-2">Elektrické přípojky</p>
                    <p className="text-sm text-gray-600">K dispozici pro stany i karavany</p>
                  </div>
                  <div className="bg-white rounded-lg p-4 shadow-sm">
                    <p className="font-semibold text-gray-900 mb-2">Domácí mazlíčci</p>
                    <p className="text-sm text-gray-600">Povoleni za příplatek 100 Kč/den</p>
                  </div>
                  <div className="bg-white rounded-lg p-4 shadow-sm">
                    <p className="font-semibold text-gray-900 mb-2">Rekreační poplatek</p>
                    <p className="text-sm text-gray-600">Povinný místní poplatek 50 Kč/den</p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          <div className="mt-8 text-center">
            <p className="text-gray-600 mb-4">
              Máte dotazy k ceníku nebo chcete rezervovat?
            </p>
            <a href="tel:+420721022279" className="text-emerald-600 font-semibold hover:text-emerald-700 transition-colors text-lg">
              📞 +420 721 022 279
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
